
/* injects from baggage-loader */

'use strict';

export default class AdminHomeController {

	constructor($log, Parse, User, Admin) {
		'ngInject';

		this.$log = $log;
		this.Parse = Parse;
		this.User = User;
		this.Admin = Admin;

		this.stats = {}

	}

	async $onInit() {

		this.widgets = [{
			label: `User${this.stats.count === 1 ? '' : 's'}`,
			icon: 'fa-user',
			gradient: 'widget-0',
			data: this.stats.user_count
		}, {
			label: `Project${this.stats.count === 1 ? '' : 's'}`,
			icon: 'fa-user',
			gradient: 'widget-1',
			data: this.stats.project_count
		}, {
			label: 'Total Dollars Raised',
			icon: 'fa-usd',	// 'fa-bank'
			gradient: 'widget-0',
			data: `$${this.stats.dollars_raised}`
		}];

		this.widgets[0].data = await this.Admin.countUsers()
		this.widgets[1].data = await this.Admin.countProjects()

	}



}



// WEBPACK FOOTER //
// ./src/app/pages/admin/home/admin.home.controller.js